import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { TranslateModule } from "@ngx-translate/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { CarouselComponent } from "@hermes/aphrodite/carousel";
import {
    ExpansionPanelComponent,
    ExpansionPanelPartDirective,
} from "@hermes/aphrodite/expansion-panel";
import { InputComponent } from "@hermes/aphrodite/fields";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { SeparatorComponent } from "@hermes/aphrodite/separator";
import { StickyWrapperComponent } from "@hermes/aphrodite/sticky-wrapper";
import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { LivechatDirectiveModule } from "@hermes/fragments/livechat-directive";
import { ProductDeliveryDetailsModule } from "@hermes/fragments/product-delivery-details";
import { ProductShippingInformationModule } from "@hermes/fragments/product-shipping-information";
import { FormHelper } from "@hermes/fragments/product-utils";
import { SeoLinksModule } from "@hermes/fragments/seo-links";
import { ShadeFinderCallToActionComponent } from "@hermes/fragments/shade-finder-button";
import { StoryBehindModule } from "@hermes/fragments/story-behind";
import { VariantItemModule } from "@hermes/fragments/variant-item";
import { VtoCallToActionComponent } from "@hermes/fragments/vto-button";
import {
    PersonalizationPageStateModule,
    UrlProductPersoHelper,
} from "@hermes/states/personalization-page";
import { ProductLocatorStateModule } from "@hermes/states/product-locator";
import { ProductImageSeoUrlPipeModule } from "@hermes/states/product-page";
import { TrayStateModule } from "@hermes/states/tray";
import { SizeGuideTrayStateModule } from "@hermes/trays/size-guide";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { SanitizePipeModule } from "@hermes/utils-generic/pipes/sanitize";
import { SpacesAroundSlashesPipeModule } from "@hermes/utils-generic/pipes/spaces-around-slashes";

import { PersonalizationCapaService } from "app/pages/personalization-page/services/personalizationCapaService/personalization-capa.service";

import { CommonProductPageModule } from "../common/common-product-page.module";

import { PerfumeEngravingSelectorComponent } from "./components/perfume-engraving-selector/perfume-engraving-selector.component";
import { SimpleProductPageComponent } from "./components/simple-product-page/simple-product-page.component";
import { SimpleProductSelectorComponent } from "./components/simple-product-selector/simple-product-selector.component";
import { WatchProductSelectorComponent } from "./components/watch-product-selector/watch-product-selector.component";

@NgModule({
    declarations: [
        SimpleProductPageComponent,
        SimpleProductSelectorComponent,
        WatchProductSelectorComponent,
        PerfumeEngravingSelectorComponent,
    ],
    imports: [
        CommonModule,
        CarouselComponent,
        CommonProductPageModule,
        ExpansionPanelComponent,
        ExpansionPanelPartDirective,
        InputComponent,
        LivechatDirectiveModule,
        ProductImageSeoUrlPipeModule,
        PersonalizationPageStateModule, // Due to CallToActionPerso
        ProductDeliveryDetailsModule,
        ProductLocatorStateModule,
        ProductShippingInformationModule,
        ReactiveFormsModule,
        RouterModule.forChild([
            { path: "", component: SimpleProductPageComponent },
        ]),
        SanitizePipeModule,
        SeoLinksModule,
        SeparatorComponent,
        SpacesAroundSlashesPipeModule,
        StickyWrapperComponent,
        SvgIconComponent,
        SizeGuideTrayStateModule,
        // For SimpleProductSelectorComponent & WatchProductSelectorComponent
        StoryBehindModule,
        TranslateModule,
        MessageBlockComponent,
        CallToActionComponent,
        TrayStateModule,
        VariantItemModule,
        VtoCallToActionComponent,
        SrOnlyNoSnippetDirective,
        ShadeFinderCallToActionComponent,
    ],
    exports: [RouterModule],
    providers: [FormHelper, PersonalizationCapaService, UrlProductPersoHelper],
})
export class SimpleProductPageModule {}
